import { getAppElement } from '../app/utils';

const PAGE_VIEW_HAS_NAVIGATION_CLASS = 'app--has-navigation';

function hasToolNavigation() {
	const app = getAppElement();

	return app.classList.contains(PAGE_VIEW_HAS_NAVIGATION_CLASS);
}

export { hasToolNavigation, PAGE_VIEW_HAS_NAVIGATION_CLASS };
